import React, { ReactElement } from "react";
import { Box, Button, Paper, Typography } from "@mui/material";
import { ShieldAlert, LogOut } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAuthentication } from "../../authentication";

const Forbidden = (): ReactElement => {
  const { t } = useTranslation("common");
  const { signoutRedirect } = useAuthentication();

  const handleLogout = (): void => {
    signoutRedirect();
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f4f6f8",
        padding: 3,
      }}
    >
      <Paper
        elevation={4}
        sx={{
          padding: 5,
          maxWidth: 480,
          textAlign: "center",
          borderRadius: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2.5,
        }}
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            backgroundColor: "#fee2e2",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "#dc2626",
          }}
        >
          <ShieldAlert size={40} />
        </Box>
        <Typography variant="h5" component="h1" fontWeight={600} color="text.primary">
          {t("forbidden.title", "Access Denied")}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t(
            "forbidden.description",
            "You are neither a DomainAdmin nor a SuperAdmin. You do not have permission to access the Domain Admin UI."
          )}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<LogOut size={16} />}
          onClick={handleLogout}
          sx={{ mt: 1, textTransform: "none", px: 3, py: 1 }}
        >
          {t("forbidden.logout", t("alert_messages.logout", "Logout"))}
        </Button>
      </Paper>
    </Box>
  );
};

export default Forbidden;
